import * as Yup from 'yup'
import { CATEGORY, MERCHANT_TYPE } from 'domains/merchant-inbound-item/constants'

const MerchantInboundItemUploadCsvSchema = Yup.object().shape({
  import_category: Yup.string().oneOf(
    Object.values(CATEGORY),
    `Harus satu dari ${Object.values(CATEGORY).join(', ')}`
  ).required('Required'),

  merchant_type: Yup.string().oneOf(
    Object.values(MERCHANT_TYPE),
    `Harus satu dari ${Object.values(MERCHANT_TYPE).join(', ')}`
  ).required('Required'),

  preorder_days: Yup.number().when('merchant_type', {
    is   : (value) => value === MERCHANT_TYPE.MERCHANT_LIST,
    then : Yup.number().positive().required(
      'preorder_days required'
    )
  }),

  file: Yup.array().required('Required')
})

export default MerchantInboundItemUploadCsvSchema